export default {

  data() {
    return {
      catsFlat: []
    }
  },
  methods: {

    flatenCats(cats, parentId = null, parentFirst = null) {
      let self = this;
      cats.map(cat => {
        self.catsFlat = [...self.catsFlat, {...cat, catParent: parentId, catParentFirst: parentFirst}];
        if(cat.bookIndexChilds && cat.bookIndexChilds.length > 0) {
          self.flatenCats(cat.bookIndexChilds, cat.bookIndexId, cat.parentId);
        }
      });
      return self.catsFlat;
    },

    flatenCatsExOtherOrThematic(cats, parent = null) {
      let self = this
      let parents = []
      // ToggleId support collapse submenu
      let toggleId = ''
      if (cats && cats.length > 0) {
        if (parent) {
          const { chapterId, title } = parent
          let indexCatParent = self.catsFlat.findIndex(catf => catf.chapterId === parent.chapterId)
          if (indexCatParent > -1) {
            toggleId = `cat_${indexCatParent}_${self.catsFlat[indexCatParent].chapterId}`
            parents = [ ...self.catsFlat[indexCatParent].parents, { chapterId, title } ]
          } else {
            parents = [{chapterId, title}]
          }
        }
        cats.map(cat => {
          self.catsFlat = [...self.catsFlat, { ...cat, parents, toggleId }]
          if(cat.listChapterChild && cat.listChapterChild.length > 0) {
            self.flatenCatsExOtherOrThematic(cat.listChapterChild, cat);
          }
        })

        return self.catsFlat;
      }
    }
  }
}